function toBase64(imgUrl) {
  // 一定要设置为let，不然图片不显示
  // console.log(imgUrl);
  let imageUrl =
    'https://ss3.baidu.com/9fo3dSag_xI4khGko9WTAnF6hhy/image/pic/item/730e0cf3d7ca7bcbb8ab733eb1096b63f724a8cb.jpg'
  let image = new Image()
  // 解决跨域问题
  image.setAttribute('crossOrigin', 'anonymous')
  // let imageUrl = imgUrl
  image.src = imageUrl
  // image.onload为异步加载
  var dataurl = ''
  image.onload = () => {
    var canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    var context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    var quality = 0.8
    // 这里的dataurl就是base64类型
    // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
    dataurl = canvas.toDataURL('image/jpeg', quality)
    return dataurl
  }
  // console.log(dataurl)
}
export default toBase64
